import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { Covid19Component } from './views/covid19/covid19.component';
import { CovidSelfAssessmentComponent } from './views/covid-self-assessment/covid-self-assessment.component';
import { Step1Component } from './views/step1/step1.component';
import { Step2Component } from './views/step2/step2.component';
import { Step3Component } from './views/step3/step3.component';
import { Step4Component } from './views/step4/step4.component';
import { Step5Component } from './views/step5/step5.component';
import { Step6Component } from './views/step6/step6.component';
import { Step7Component } from './views/step7/step7.component';
import { BuildChatbotComponent } from './views/build-chatbot/build-chatbot.component';
import { SelfIsolationAssessmentComponent } from './views/self-isolation-assessment/self-isolation-assessment.component';


const routes: Routes = [
  { path: '', component: Covid19Component },
  { path: 'covid-19', component: Covid19Component },
  { path: 'covid-19/self-assessment', component: CovidSelfAssessmentComponent },
  { path: 'covid-19/self-assessment/1', component: Step1Component },
  { path: 'covid-19/self-assessment/2', component: Step2Component },
  { path: 'covid-19/self-assessment/3', component: Step3Component },
  { path: 'covid-19/self-assessment/4', component: Step4Component },
  { path: 'covid-19/self-assessment/5', component: Step5Component },
  { path: 'covid-19/self-assessment/6', component: Step6Component },
  { path: 'covid-19/self-assessment/7', component: Step7Component },
  { path: 'covid-19/build-free-covid-19-ai-chatbot', component: BuildChatbotComponent },
  { path: 'covid-19/self-isolation', component: SelfIsolationAssessmentComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
